import { CreditCardIcon } from '@heroicons/react/20/solid';
import { LockClosedIcon } from '@heroicons/react/24/outline';

import { useManageBilling } from '../hooks/manage-billing';
import { PrimaryButton } from './buttons';
import { EmptyState } from './empty-state';
import { Spinner } from './spinner';

// Only rendered for disabled stores WITH a subscription (lapsed payment).
// Disabled stores without a subscription are redirected to /onboard/$storeId
// by storeLayout.beforeLoad before this component mounts.
export const DisabledStore: React.FC = () => {
  const { showBilling, loadingBilling } = useManageBilling();

  return (
    <EmptyState
      icon={<LockClosedIcon className="size-8" />}
      title="Your store is disabled"
      description="Your subscription needs attention. Update your payment information to re-enable your store."
      action={
        <PrimaryButton onClick={showBilling} disabled={loadingBilling}>
          <CreditCardIcon className="h-5 w-5" />
          {loadingBilling ? <Spinner /> : 'Manage Billing'}
        </PrimaryButton>
      }
      footnote={
        <>
          Need help?{' '}
          <a href="mailto:hello@liquorstore.tech" className="text-primary-500">
            hello@liquorstore.tech
          </a>
        </>
      }
    />
  );
};
